import header from "./bright-living-room.jpg";
import section1 from "./living-room.jpg";
import section2 from "./floor-plan-of-an-apartment.webp";
import section3 from "./treppenhaus.jpg";
import section4 from "./detailed-floor-plan-of-an-apartment.webp";
import section5 from "./light-living-room.webp";
import section6 from "./modern-kitchen.webp";

export { header, section1, section2, section3, section4, section5, section6 };
